import { CompanyActualVsBudgetView } from '@/components/custom/companies/financials/actual-vs-budget-view'
import { usePortalActualVsBudget } from '@/hooks/use-portal-financials'
import { isActualVsBudgetEnabled } from '@/features/actual-vs-budget-production/access'
import { PortalCompositeMetricChart } from '@/components/custom/portal/portal-composite-metric-chart'
import { PortalFinancialStatCards } from '@/components/custom/portal/portal-financial-stat-cards'
import { PortalFinancialsTable } from '@/components/custom/portal/portal-financials-table'
import type {
  CompanyFinancialsTrailingPeriod,
  CompanyFinancialsView,
} from '@/services/companies.service'
import type { PortalTabValue } from '@/components/custom/portal/portal-tabs'

interface PortalFinancialsTabProps {
  initialTrailingPeriod?: CompanyFinancialsTrailingPeriod
  initialView?: CompanyFinancialsView
  onNavigateToFinancials: (
    tab: PortalTabValue,
    trailingPeriod?: string,
    view?: string
  ) => void
}

export function PortalFinancialsTab({
  initialTrailingPeriod,
  initialView,
  onNavigateToFinancials,
}: PortalFinancialsTabProps) {
  return (
    <div className="space-y-4">
      <section>
        <PortalFinancialStatCards
          onNavigateToFinancials={onNavigateToFinancials}
        />
      </section>

      {isActualVsBudgetEnabled(import.meta.env) ? (
        <PortalActualVsBudget />
      ) : null}

      <PortalCompositeMetricChart />

      <section>
        <PortalFinancialsTable
          initialTrailingPeriod={initialTrailingPeriod}
          initialView={initialView}
        />
      </section>
    </div>
  )
}

function PortalActualVsBudget() {
  const query = usePortalActualVsBudget()
  return (
    <CompanyActualVsBudgetView
      data={query.data}
      isLoading={query.isLoading}
      isError={query.isError}
      onRetry={() => {
        void query.refetch()
      }}
    />
  )
}
